import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";
import { FlagIcon } from "react-flag-kit";
import { ChevronDown } from "lucide-react";
import { updateCountry } from "../../actions/countryActions";

const ToggleCountry = ({ className, dark = false, ...props }) => {
	const dispatch = useDispatch();
	const [isOpen, setIsOpen] = useState(false);
	const [country, setCountry] = useState(useSelector((state) => state.country));

	const countries = [
		{ value: "Canada", code: "CA", currency: "CAD" },
		{ value: "USA", code: "US", currency: "USD" },
	];

	const handleCountryChange = (newCountry) => {
		setCountry(newCountry);
		dispatch(updateCountry(newCountry));
		setIsOpen(false);
	};

	const bounceTransition = {
		duration: 0.4,
		ease: [0.68, -0.25, 0.265, 1.25],
	};

	// Find current country data
	const currentCountry = countries.find((c) => c.value === country);

	return (
		<div className={`relative ${className}`} {...props}>
			{/* Selected Country Button */}
			<motion.button
				onClick={() => setIsOpen(!isOpen)}
				className={`flex items-center gap-2 px-3 py-2 rounded-xl transition-colors ${
					dark
						? "text-gray-900 hover:bg-gray-100"
						: "text-white hover:bg-white/10"
				}`}
				whileHover={{ scale: 1.05 }}
				whileTap={{ scale: 0.95 }}
				transition={bounceTransition}
			>
				<FlagIcon code={currentCountry.code} className="w-5 h-5 rounded-full" />
				<span className="text-sm font-medium">{currentCountry.currency}</span>
				<motion.div
					animate={{ rotate: isOpen ? 180 : 0 }}
					transition={bounceTransition}
				>
					<ChevronDown className="w-4 h-4" />
				</motion.div>
			</motion.button>

			{/* Dropdown Menu */}
			<AnimatePresence>
				{isOpen && (
					<motion.div
						initial={{ opacity: 0, y: 10, scale: 0.95 }}
						animate={{ opacity: 1, y: 0, scale: 1 }}
						exit={{ opacity: 0, y: 10, scale: 0.95 }}
						transition={bounceTransition}
						className={`absolute right-0 top-full mt-2 p-1 rounded-xl shadow-lg z-50 ${
							dark ? "bg-white" : "bg-secondary"
						}`}
					>
						{countries.map((countryOption) => (
							<motion.button
								key={countryOption.value}
								onClick={() => handleCountryChange(countryOption.value)}
								className={`flex items-center gap-3 w-full px-4 py-2 rounded-lg transition-colors ${
									dark
										? "hover:bg-gray-100 text-gray-900"
										: "hover:bg-primary text-white"
								} ${country === countryOption.value ? "bg-primary/10" : ""}`}
								whileHover={{ x: 4 }}
								transition={bounceTransition}
							>
								<FlagIcon
									code={countryOption.code}
									className="w-5 h-5 rounded-full"
								/>
								<span className="text-sm font-medium">
									{countryOption.currency}
								</span>
							</motion.button>
						))}
					</motion.div>
				)}
			</AnimatePresence>
		</div>
	);
};

export default ToggleCountry;
